var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUseThisRuleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2540",
    "data-name": "Group 2540",
    transform: "translate(-304 -536)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_822",
    "data-name": "Rectangle 822",
    width: 18,
    height: 18,
    transform: "translate(304 536)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "receipt-outline",
    transform: "translate(273.143 489.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M160,58.1V48l1.122.561L162.245,48l1.12.561L164.5,48l1.112.561L166.728,48l1.12.561L168.98,48l1.123.561L171.225,48v7.858",
    transform: "translate(-123.511)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M47.715,272v3.929a2.806,2.806,0,0,1-2.806,2.806h0a2.806,2.806,0,0,1-2.806-2.806v-1.684H32.561a.556.556,0,0,0-.561.561c0,2.245.236,3.929,2.806,3.929h10.1",
    transform: "translate(0 -216.142)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M224,144h6.613m-4.408,3.49h4.408",
    transform: "translate(-185.143 -92.364)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseThisRuleIcon);
export default __webpack_public_path__ + "static/media/use-this-rule-icon.6977c9e25a66fad764c98d08dcefe0cb.svg";
export { ForwardRef as ReactComponent };